export const NOTIFICIATION_TOAST_DELAY = 10000